import styled from "styled-components";
import {TextField} from "@mui/material";
import {media} from "../../../theme";

export const StyledCard = styled.div`
    width: 100%;
    max-width: 450px;
    background: ${({theme}) => theme.palette.background.paper};
    border: 1px solid ${({theme}) => theme.palette.dividers.subtle};
    border-radius: 40px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    ${media.sm} {
        padding: 32px;
        gap: 10px;
    }

    ${media.md} {
        padding: 40px;
        gap: 12px;
    }
`;

export const Header = styled.h1`
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    color: ${({theme}) => theme.palette.text.primary};
    letter-spacing: -0.02em;
    text-align: center;
    width: 100%;
    margin: 0;

    ${media.sm} {
        font-size: 22px;
        line-height: 30px;
    }

    ${media.md} {
        font-size: 24px;
        line-height: 33px;
    }
`;

export const Subtext = styled.p`
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    color: ${({theme}) => theme.palette.text.secondary};
    letter-spacing: -0.02em;
    text-align: center;
    width: 100%;
    margin: 0 0 8px 0;

    ${media.sm} {
        font-size: 14px;
        line-height: 20px;
    }
`;

export const StyledForm = styled.form`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;

    ${media.md} {
        gap: 22px;
    }
`;

export const StyledTextField = styled(TextField)`
    && {
        width: 100%;

        .MuiOutlinedInput-root {
            border-radius: 16px;
            background-color: ${({theme}) => theme.palette.background.input};;

            & fieldset {
                border-color: #e0e0e0;
            }

            &:hover fieldset {
                border-color: ${({theme}) => theme.palette.dividers.subtle};
            }

            &.Mui-focused fieldset {
                border-color: ${({theme}) => theme.palette.dividers.focus};
            }

            &.Mui-error fieldset {
                border-color: ${({theme}) => theme.palette.error.main};
            }

            &.Mui-error:hover fieldset {
                border-color: ${({theme}) => theme.palette.error.main};
            }

            &.Mui-error.Mui-focused fieldset {
                border-color: ${({theme}) => theme.palette.error.main};
            }
        }

        .MuiInputLabel-root {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            letter-spacing: -0.02em;
            color: ${({theme}) => theme.palette.text.primary};
            
            &.Mui-focused {
                color: ${({theme}) => theme.palette.text.primary};
            }

            &.Mui-error {
                color: ${({theme}) => theme.palette.error.main};
            }

            &.Mui-error.Mui-focused {
                color: ${({theme}) => theme.palette.error.main};
            }
        }

        input {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: ${({theme}) => theme.palette.text.primary};
        }

        input:-webkit-autofill {
            box-shadow: 0 0 0 1000px ${({theme}) => theme.palette.background.input} inset;
            -webkit-text-fill-color: ${({theme}) => theme.palette.text.primary};
        }
    }
`;